export const theme = {
    colors: {
      primary: "#727a77",
      secondary: "#ced7d2",
      accent: "#08d5d5",
      background: "#f9f9f9",
      hover: "#cec6e3",
      text: "rgb(8, 213, 213)",
      buttonText: "hsl(235, 16%, 15%)",
      red: "#ff5757"
    },
    fontSize: {
      small: "1rem",
      medium: "1.25rem",
      large: "2.5rem",
    },

    breakpoint: {
      mobile: 767
    }
  };